export default __webpack_public_path__ + "static/media/shape3.7940c0b8.svg";